/**
 * lib/version.js — Single source of truth for the app version string.
 *
 * Consumers:
 *   • pages/SuperAdmin.js         (re-exports as SUPERADMIN_VERSION for
 *                                  backwards compatibility)
 *   • components/settings/HelpSection.js (Help & Orientation panel)
 *   • Any future about-page or diagnostic dump
 *
 * Why this file exists:
 *   HelpSection previously hard-coded the version string, so the "Version
 *   v_._._" label under Help & Orientation drifted from the value shown
 *   in SuperAdmin every deploy. Coupling them via a shared constant is
 *   the smallest fix. Importing from pages/SuperAdmin.js directly would
 *   have dragged that entire heavy page into the Settings bundle, so we
 *   keep the constant here in a leaf module.
 *
 * Update convention:
 *   Bump this constant with every release (matches the pattern documented
 *   in RELEASE_NOTES.json). Do not fork it. Do not hard-code the version
 *   anywhere else in the app.
 */
export const APP_VERSION = 'v3.25.3';
